import { Tags } from "@modules";
import { Breadcrumb } from "@components";
import { useParams } from "react-router-dom";

export default function EditPage() {
  const { id } = useParams();

  return (
    <div className="container max-content">
      <Breadcrumb
        data={[
          { title: "Tags", href: "/tags" },
          { title: "Edit Tag", href: `/tags/edit/${id}` },
        ]}
      />
      <h1 className="mb-8 text-3xl">Edit Tag</h1>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <Tags.Edit id={id} />
        </div>
      </div>
    </div>
  );
}
